import styled from 'styled-components';
import { rgba } from 'polished';

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;
`;

export const Fieldset = styled.fieldset`
	margin-bottom: 2rem;
`;

export const Legend = styled.legend``;

export const Label = styled.label`
	font-weight: 700;
`;

export const FormItem = styled.div`
	margin-bottom: 1.5rem;
`;

export const FormText = styled.p`
	font-weight: 700;
	color: ${({ theme }) => rgba(theme['white'], 0.5)};
`;

export const ButtonGroup = styled.div`
	display: inline-flex;
	margin-bottom: 1rem;

	button {
		margin: 0;

		&:not(:first-child) {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
		}

		&:not(:last-child) {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}
	}
`;

export const AbsoluteContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
`;
